interface ICardExpirationDateFormatValidatorReturn {
  isValid: boolean;
}

const cardExpirationValidatorRegExp = /^(\d{2})\/(\d{2}|\d{4})$/;

const cardExpirationDateFormatValidator = (
  cardExpirationDate: string,
): ICardExpirationDateFormatValidatorReturn => {
  const isValid = cardExpirationValidatorRegExp.test(cardExpirationDate);
  return { isValid };
};

export default cardExpirationDateFormatValidator;
